import React from 'react';
import { prettifyFileSize } from '../../MessageInput/hooks/utils';
export const FileSizeIndicator = ({ fileSize, maximumFractionDigits, }) => {
    const actualFileSize = typeof fileSize === 'string' ? parseFloat(fileSize) : fileSize;
    if (typeof actualFileSize === 'undefined' || !Number.isFinite(Number(actualFileSize))) {
        return null;
    }
    return (React.createElement("span", { className: 'str-chat__message-attachment-file--item-size', "data-testid": 'file-size-indicator' }, prettifyFileSize(actualFileSize, maximumFractionDigits)));
};
